import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionBranding = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"type": "page",
			"properties": {
				"title": [
					[
						"Бренд"
					]
				]
			},
			"content": [
				"6955a49b-7f45-42bb-8cfc-918bf2022e17",
				"769a0764-b0a2-41b7-be52-3705a22d6cdb",
				"9da68809-3862-4696-a70d-59e4f877a587",
				"6399d5ab-cd1a-4e6d-a196-624372dcdf26",
				"23a109c3-32d4-43e9-8208-e9144a51d3d9",
				"0483ae59-9c61-4477-ac92-51607123d9b0",
				"71181440-3a6d-411a-b155-9df72340128d",
				"d759d110-6a8b-4a65-816c-0f5af86250f6",
				"b1e2687c-1b20-4cc6-80d7-27b1e4194bed",
				"8c845ec8-4d77-45ae-9685-8910db25341c",
				"8d9ea4db-0801-4524-915b-8aeb18fc32a7",
				"d1548931-5cbb-4fc3-b195-38f73c075810",
				"0ca7c244-7dbf-4e8f-9ac1-8399cbbaa996",
				"83c86c74-3325-45e4-b28a-93df602d9c41",
				"f1c16f72-6797-4829-bfc5-2904d807bfd0",
				"a067416d-eb3d-4f20-9d42-69417187f7b2",
				"c77b908e-9ee3-40b6-abc9-d2f2e19db7c6",
				"5e584a52-74c6-4f00-85d9-2fea47bb9b12",
				"542599f3-513a-4e11-8619-b70f47275859",
				"1b7445c0-d438-47a9-b751-9f7ef9b175f3",
				"644b71bd-6cca-4b46-862f-ae442ddc52bb",
				"f2352fb3-e7de-4f8f-b80d-2645887733b2",
				"0272a434-ee51-47b1-ade7-a9f20aa6f093",
				"e305c268-cfcd-4aed-bab5-ac5d049fc3ae",
				"2bee9a64-f9ee-4f34-bc1f-cf1cda683149",
				"b349df2d-84c1-4bc7-8923-107cbe998250",
				"e547b753-82f5-4b79-988d-d22c4660e14c",
				"583aa76e-9a78-4389-8f56-f66937ac60f9",
				"1c5d9dad-25d4-4212-9fc6-31a05378f5dd",
				"7b90b866-d071-4e3b-99e1-e724a75e6f53",
				"67fb054e-6f1a-4b35-aed2-d8e522c5baf7",
				"09a1fc6d-eb94-43ed-ba37-58f013ba1964",
				"bd3c1c99-c775-47a8-b603-d21dffea2949",
				"61002c7b-392b-4756-a1ee-ed3ef55d1883",
				"33297b79-9884-43a7-a8f9-ab3b3f4e745f",
				"e8a8f0dc-fa50-4eb8-b9b3-02bc3efcbeff",
				"1c2d161a-b43f-4ee2-b29d-f83dfa735033",
				"535d0bff-4df1-4f74-afbb-a2821602d6b4",
				"2e3bed04-90e0-4a00-a5db-5bf5ada2e597",
				"9bdf3e51-af40-45b0-b227-e80aaeef486d",
				"ba5ea0e3-6688-438c-8ab9-fcf10e60dc92",
				"f3f752d9-0147-4df1-b079-04fedba207cb",
				"5ab8d29a-a29a-4ee3-a720-2aad4552bf4f",
				"2a12eb64-d75f-42f4-9e3e-0af134904327",
				"9b76e85a-6e94-4e9f-b379-6ee6128e701a",
				"f207a5d0-b580-4e78-a325-4f3773ba1274",
				"9ca0568e-060c-453d-8365-d8675a6ac3fc",
				"f14b8a48-7f12-496c-8f4e-352fbc8a1970",
				"3437c593-a1bf-486f-8ae1-e3a478c1d191",
				"1b819677-e81a-4290-b6bf-f59b2c674ac5",
				"057e58a0-b989-4d47-bbe8-f6cc9eadf1de",
				"93febb3e-6299-4426-baf1-c431c7baedef",
				"577011cb-0a80-4591-8141-85dd49dc07ed",
				"28e5a203-be5a-44d8-9ef7-84f112efd851",
				"f1e41d63-acce-4543-a5df-dd05e0ab6dc9",
				"b062103c-dcc1-4230-b904-0043b33a096a",
				"ab60cdaa-ed56-48d9-a3e6-de292ae336ef",
				"f1ed9f78-8382-4e41-a244-4be660b73077",
				"681365f4-d174-42b7-b6e9-664d347736b2",
				"c60557d4-f7ba-4e1f-a306-7cd848c27f91"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9f64f03f-ac18-45c6-9970-a32fac9938dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"ce0381bc-ae9e-4831-81ae-ce3a6e329aef"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6955a49b-7f45-42bb-8cfc-918bf2022e17",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "b9112d6a-87e7-451a-98fb-641852caeec5",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "769a0764-b0a2-41b7-be52-3705a22d6cdb",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/branding\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9da68809-3862-4696-a70d-59e4f877a587",
			"type": "text",
			"properties": {
				"title": [
					[
						"Бренд — это цифровая личность наших продуктов. Мы соблюдаем его константы — логотип и палитру — и свободно работаем с визуальным языком в коммуникациях, рекламных кампаниях и спецпроектах."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f76fe660-a3f1-473b-9df6-603ce02b152e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6399d5ab-cd1a-4e6d-a196-624372dcdf26",
			"type": "header",
			"properties": {
				"title": [
					[
						"Фирменные цвета"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0251fdba-8af1-4664-b0ce-6948f4fa3d73",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "23a109c3-32d4-43e9-8208-e9144a51d3d9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основная палитра строится вокруг нейтральной гаммы, основного синего цвета VK и акцентного зеленого."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8305cce7-d6a9-4b7c-9d1a-3eba62832b65",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0483ae59-9c61-4477-ac92-51607123d9b0",
			"type": "image",
			"properties": {
				"size": [
					[
						"140.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1d41b738-ae98-4866-b31a-31bba7c8083d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1d41b738-ae98-4866-b31a-31bba7c8083d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"1d41b738-ae98-4866-b31a-31bba7c8083d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0483ae59-9c61-4477-ac92-51607123d9b0.png"
		},
		{
			"id": "71181440-3a6d-411a-b155-9df72340128d",
			"type": "header",
			"properties": {
				"title": [
					[
						"Логотип"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1bba4428-580f-4ea1-9654-985c498da84e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d759d110-6a8b-4a65-816c-0f5af86250f6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Логотип — это символ нашего подхода к решению проблем пользователей. Он простой, дружелюбный, понятный, современный."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eeb05c77-2891-4122-8477-550a1e324be5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1e2687c-1b20-4cc6-80d7-27b1e4194bed",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Современный. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Цветовая палитра и шрифтовое решение, простота и геометричность знаков, особенности использования в логотипах продуктов — всё это в духе времени."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf8f9f2b-c33d-4aef-b47f-d002386a5aa1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c845ec8-4d77-45ae-9685-8910db25341c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Органичный. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Логотип хорошо работает во всех средах: веб-сервисах и мобильных приложениях, промоматериалах и соцсетях, печатной продукции и физическом пространстве."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a71d4475-6434-46da-b18e-c271481e8330",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8d9ea4db-0801-4524-915b-8aeb18fc32a7",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Практичный. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Мы предусмотрели большую гибкость использования логотипа: адаптивные названия продуктов, упрощённые цветовые схемы и другие полезные решения."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6de89018-a71c-487b-919f-310eb37035b2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1548931-5cbb-4fc3-b195-38f73c075810",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "892d6779-c40b-4c4b-ac24-bd67bc19ceb2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ca7c244-7dbf-4e8f-9ac1-8399cbbaa996",
			"type": "image",
			"properties": {
				"size": [
					[
						"41.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9d413cf5-7af7-44e6-b484-e31340098666/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9d413cf5-7af7-44e6-b484-e31340098666/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"9d413cf5-7af7-44e6-b484-e31340098666"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0ca7c244-7dbf-4e8f-9ac1-8399cbbaa996.png"
		},
		{
			"id": "83c86c74-3325-45e4-b28a-93df602d9c41",
			"type": "image",
			"properties": {
				"size": [
					[
						"39.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0889c2c8-5ce7-445e-ad84-42b41078d61f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0889c2c8-5ce7-445e-ad84-42b41078d61f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"0889c2c8-5ce7-445e-ad84-42b41078d61f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/83c86c74-3325-45e4-b28a-93df602d9c41.png"
		},
		{
			"id": "f1c16f72-6797-4829-bfc5-2904d807bfd0",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://cloud.mail.ru/public/V59Y/K2jho1JHA"
					]
				],
				"title": [
					[
						"Папка из Облака Mail.ru&#x0A;Logo SVG"
					]
				],
				"caption": [
					[
						"Скачать логотипы"
					]
				],
				"description": [
					[
						"Скачивайте файлы из папки или сохраняйте к себе в Облако"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://cloud.imgsmail.ru/cloud.mail.ru/hashes/img/305ee81aa222132bf8f8.svg",
				"bookmark_cover": "https://cloud.imgsmail.ru/cloud.mail.ru/hashes/img/shared/8aee1540590d1c8fec88.png"
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a067416d-eb3d-4f20-9d42-69417187f7b2",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Построение логотипа"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4124fcac-65a0-41be-879c-0fe062b183d7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c77b908e-9ee3-40b6-abc9-d2f2e19db7c6",
			"type": "text",
			"properties": {
				"title": [
					[
						"За основу отступов и построения логотипа взят диаметр внутренней окружности символа mail. Отступ от символа до текстовой части равен внутреннему диаметру @."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e584a52-74c6-4f00-85d9-2fea47bb9b12",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы отказались от использования плашки вокруг логотипа. Этот вариант считается устаревшим и не используется."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "542599f3-513a-4e11-8619-b70f47275859",
			"type": "image",
			"properties": {
				"size": [
					[
						"45.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac6fba24-998c-49c5-af4e-f4698d85c1e6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac6fba24-998c-49c5-af4e-f4698d85c1e6/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"ac6fba24-998c-49c5-af4e-f4698d85c1e6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/542599f3-513a-4e11-8619-b70f47275859.png"
		},
		{
			"id": "1b7445c0-d438-47a9-b751-9f7ef9b175f3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Охранное поле логотипа"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "100872d9-f400-4104-a355-ba94bb4592dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "644b71bd-6cca-4b46-862f-ae442ddc52bb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Запрещено располагать элементы графики на охранном поле. Также охранное поле показывает минимально разрешенное расстояние расположения логотипа от края макета."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b294f326-eaa9-40ea-801c-415ee69bf447",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f2352fb3-e7de-4f8f-b80d-2645887733b2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Минимальное значение охранного поля логотипа строится на диаметре внутренней окружности символа @."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9b07f533-c67e-4b77-b87a-704709a4c5b5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0272a434-ee51-47b1-ade7-a9f20aa6f093",
			"type": "image",
			"properties": {
				"size": [
					[
						"46.9KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b60ca5bd-89f5-408b-83c2-3007ff6dc530/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b60ca5bd-89f5-408b-83c2-3007ff6dc530/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"b60ca5bd-89f5-408b-83c2-3007ff6dc530"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0272a434-ee51-47b1-ade7-a9f20aa6f093.png"
		},
		{
			"id": "e305c268-cfcd-4aed-bab5-ac5d049fc3ae",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Запрещенное использование логотипа"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1a65893e-a701-4172-a860-a55a6eacd6fa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2bee9a64-f9ee-4f34-bc1f-cf1cda683149",
			"type": "column_list",
			"content": [
				"fb9e70bd-e336-466e-90b4-754864386d92",
				"853bd534-6c65-4c3b-809b-fd098de87bea"
			],
			"format": {
				"copied_from_pointer": {
					"id": "05db26ed-b346-40f1-baf5-66790d15d461",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b349df2d-84c1-4bc7-8923-107cbe998250",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Логотипы продуктов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a844f83c-f673-4dce-a478-2ed784c867d5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e547b753-82f5-4b79-988d-d22c4660e14c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Основная версия логотипа продукта состоит из знака и названия продукта. Ее используют на всех ресурсах и носителях внутри Mail. Все логотипы продуктов под брендом Mail выполняются в едином стиле."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "97c42786-ab6d-4dfc-80be-8e7d35f52583",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "583aa76e-9a78-4389-8f56-f66937ac60f9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Использовать логотип без названия продукта можно только в Почте Mail или на главной странице Mail."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "12c5147d-8d67-4059-b994-4b48b38c5e2a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1c5d9dad-25d4-4212-9fc6-31a05378f5dd",
			"type": "image",
			"properties": {
				"size": [
					[
						"76.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0e4a1591-a02c-4e8c-8558-64e6154e7ead/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0e4a1591-a02c-4e8c-8558-64e6154e7ead/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"0e4a1591-a02c-4e8c-8558-64e6154e7ead"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1c5d9dad-25d4-4212-9fc6-31a05378f5dd.png"
		},
		{
			"id": "7b90b866-d071-4e3b-99e1-e724a75e6f53",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Иконки сервисов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b349df2d-84c1-4bc7-8923-107cbe998250",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67fb054e-6f1a-4b35-aed2-d8e522c5baf7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки сервисов это миниатюры которые используют продукты Mail. Иконки применяются в магазинах приложений, для запуска наших продуктов, в виде favicon браузера, а также могут быть внутри продуктов для кросс переходов."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "09a1fc6d-eb94-43ed-ba37-58f013ba1964",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки имеют единую палитру, размер и радиус закругления. Не допускается использовать рядом круглые и квадратные иконки. "
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd3c1c99-c775-47a8-b603-d21dffea2949",
			"type": "image",
			"properties": {
				"size": [
					[
						"55.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b497215b-2228-4b8f-b19d-cbb5bba93954/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b497215b-2228-4b8f-b19d-cbb5bba93954/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5054945054945055,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"b497215b-2228-4b8f-b19d-cbb5bba93954"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/bd3c1c99-c775-47a8-b603-d21dffea2949.png"
		},
		{
			"id": "61002c7b-392b-4756-a1ee-ed3ef55d1883",
			"type": "text",
			"properties": {
				"title": [
					[
						"По аналогии с логотипом отступы в иконках наследуются от диаметра внутренней окружности в логотипе @. Допускается оптическая компенсация элементов внутри иконок."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "33297b79-9884-43a7-a8f9-ab3b3f4e745f",
			"type": "image",
			"properties": {
				"size": [
					[
						"79.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/495241e3-8eb1-4ccd-a125-b0e9472bf9a9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/495241e3-8eb1-4ccd-a125-b0e9472bf9a9/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5054945054945055,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"495241e3-8eb1-4ccd-a125-b0e9472bf9a9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/33297b79-9884-43a7-a8f9-ab3b3f4e745f.png"
		},
		{
			"id": "e8a8f0dc-fa50-4eb8-b9b3-02bc3efcbeff",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://cloud.mail.ru/public/5UJF/sMjjwTfXn"
					]
				],
				"title": [
					[
						"Папка из Облака Mail.ru&#x0A;Icons"
					]
				],
				"caption": [
					[
						"Скачать иконки сервисов"
					]
				],
				"description": [
					[
						"Скачивайте файлы из папки или сохраняйте к себе в Облако"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://cloud.imgsmail.ru/cloud.mail.ru/hashes/img/305ee81aa222132bf8f8.svg",
				"bookmark_cover": "https://cloud.imgsmail.ru/cloud.mail.ru/hashes/img/shared/7bbf453ccaf9954ff0da.png"
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1c2d161a-b43f-4ee2-b29d-f83dfa735033",
			"type": "text",
			"properties": {
				"title": [
					[
						"При создании иконок мы руководствовались следующими принципами:"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "535d0bff-4df1-4f74-afbb-a2821602d6b4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Упрощение\nМаксимальное упрощение символов и смелая работа с формой. Мы оставляем только суть и избавляемся от лишних и устаревших деталей. "
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e3bed04-90e0-4a00-a5db-5bf5ada2e597",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Работа с метафорой\nИзбавляемся от устаревших ассоциаций в графике, например, от бумажного календаря"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9bdf3e51-af40-45b0-b227-e80aaeef486d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Работа с формой\nВ работе с формой графики и иконок мы продолжаем пластику логотипа, где линия формирует сюжет визуального символа."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba5ea0e3-6688-438c-8ab9-fcf10e60dc92",
			"type": "header",
			"properties": {
				"title": [
					[
						"Маскот продуктов Mail"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f3f752d9-0147-4df1-b079-04fedba207cb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Понимающий, технологичный и умный помощник, который интересно и вовлекающе расскажет про крутые технологии сета Mail и поможет упростить работу с задачами."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ab8d29a-a29a-4ee3-a720-2aad4552bf4f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Байт служит проводником умных технологий  сервисов Mail, таких как ML и GPT. Марусю Байт не представляет, а ссылается на неё, так как у Маруси есть свой бренд."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2a12eb64-d75f-42f4-9e3e-0af134904327",
			"type": "image",
			"properties": {
				"size": [
					[
						"365.3KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4c3befc1-6a8b-4aca-9740-9e251b96713f/image.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4c3befc1-6a8b-4aca-9740-9e251b96713f/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"4c3befc1-6a8b-4aca-9740-9e251b96713f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2a12eb64-d75f-42f4-9e3e-0af134904327.png"
		},
		{
			"id": "9b76e85a-6e94-4e9f-b379-6ee6128e701a",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Кто такой Байт?"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7b90b866-d071-4e3b-99e1-e724a75e6f53",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f207a5d0-b580-4e78-a325-4f3773ba1274",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Умный помощник\nПонимающий, технологичный и умный помощник, который интересно и вовлекающе расскажет про крутые технологии сета Mail и поможет упростить работу с задачами."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9ca0568e-060c-453d-8365-d8675a6ac3fc",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Проводник по технологиям\nБайт служит проводником умных технологий  сервисов Mail, таких как ML и GPT. "
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f14b8a48-7f12-496c-8f4e-352fbc8a1970",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Не нейросеть\nБайт не ищет фото, не пишет текст и не придумывает идеи. Всё это делает нейросеть от Mail — Байт всегда об этом скажет."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3437c593-a1bf-486f-8ae1-e3a478c1d191",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Использование в коммуникациях"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1b819677-e81a-4290-b6bf-f59b2c674ac5",
			"type": "text",
			"properties": {
				"title": [
					[
						"В промо от Mail Байт может выступать как главным героем повествования, например, рассказывать о новых фичах в блоге, так и второстепенным участником сторителлинга."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "057e58a0-b989-4d47-bbe8-f6cc9eadf1de",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Байт никогда не используется в рекламе сторонних сервисов или продуктов внутри интерфейсов Mail."
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93febb3e-6299-4426-baf1-c431c7baedef",
			"type": "image",
			"properties": {
				"size": [
					[
						"244.5KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2a89cb74-e0fd-44bd-9a1f-48a962942574/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2a89cb74-e0fd-44bd-9a1f-48a962942574/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"2a89cb74-e0fd-44bd-9a1f-48a962942574"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/93febb3e-6299-4426-baf1-c431c7baedef.png"
		},
		{
			"id": "577011cb-0a80-4591-8141-85dd49dc07ed",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Использование в интерфейсах"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28e5a203-be5a-44d8-9ef7-84f112efd851",
			"type": "text",
			"properties": {
				"title": [
					[
						"Внутри продуктов Байт встречается в промо-коммуникации, интерфейсных иллюстрациях и в качестве постоянного источника уведомлений от самого продукта. "
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f1e41d63-acce-4543-a5df-dd05e0ab6dc9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Список частей интерфейса где появляется Байт:"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b062103c-dcc1-4230-b904-0043b33a096a",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Экраны загрузки приложений и сервисов"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab60cdaa-ed56-48d9-a3e6-de292ae336ef",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Места где пользователь взаимодействует с нейросетями. Байт как помощьник и проводник"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f1ed9f78-8382-4e41-a244-4be660b73077",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Всплывающие окна с новыми функциями продукта"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "681365f4-d174-42b7-b6e9-664d347736b2",
			"type": "numbered_list",
			"properties": {
				"title": [
					[
						"Пустые экраны"
					]
				]
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c60557d4-f7ba-4e1f-a306-7cd848c27f91",
			"type": "image",
			"properties": {
				"size": [
					[
						"565.2KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5b4a8d4a-d22c-4724-8398-d4f9f5375aa2/image.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5b4a8d4a-d22c-4724-8398-d4f9f5375aa2/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
			"parent_table": "block",
			"file_ids": [
				"5b4a8d4a-d22c-4724-8398-d4f9f5375aa2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c60557d4-f7ba-4e1f-a306-7cd848c27f91.png"
		},
		{
			"id": "fb9e70bd-e336-466e-90b4-754864386d92",
			"type": "column",
			"content": [
				"4f838b4f-4e01-4ee5-b818-47a6821e1a55",
				"28ce0dec-3577-4c29-b0cb-c932cb0aa806",
				"18bad86f-d59a-4745-8330-b0b82197b7e2"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "93a34f92-f204-419f-9f2e-215eab48ab45",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2bee9a64-f9ee-4f34-bc1f-cf1cda683149",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "853bd534-6c65-4c3b-809b-fd098de87bea",
			"type": "column",
			"content": [
				"df48344a-82f9-4507-8ea1-b0f945de4a3b",
				"66810c39-00de-4856-8e70-2fbc4fceba15",
				"c405eacf-591a-42e7-95df-200b03ff9777"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b97a5ee6-b769-4a5f-9e37-cf95baa927c8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2bee9a64-f9ee-4f34-bc1f-cf1cda683149",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4f838b4f-4e01-4ee5-b818-47a6821e1a55",
			"type": "image",
			"properties": {
				"size": [
					[
						"40.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d51e2f9f-b4a6-47f0-99ed-36eb3048c501/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d51e2f9f-b4a6-47f0-99ed-36eb3048c501/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"block_preserve_scale": true
			},
			"parent_id": "fb9e70bd-e336-466e-90b4-754864386d92",
			"parent_table": "block",
			"file_ids": [
				"d51e2f9f-b4a6-47f0-99ed-36eb3048c501"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4f838b4f-4e01-4ee5-b818-47a6821e1a55.png"
		},
		{
			"id": "28ce0dec-3577-4c29-b0cb-c932cb0aa806",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нельзя:\n• изменять цвета логотипа,\n• изменять шрифтовое написание,\n• менять расположение элементов логотипа,\n• использовать шрифтовое написание отдельно от знака,\n• использовать устаревшую версию логотипа."
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "3ae3ebee-0dc3-4f2e-9e2a-999f1e0b3603",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fb9e70bd-e336-466e-90b4-754864386d92",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "18bad86f-d59a-4745-8330-b0b82197b7e2",
			"type": "text",
			"parent_id": "fb9e70bd-e336-466e-90b4-754864386d92",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "df48344a-82f9-4507-8ea1-b0f945de4a3b",
			"type": "image",
			"properties": {
				"size": [
					[
						"89.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b291bdb0-3790-4929-b407-b5b1e072fa60/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 384,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b291bdb0-3790-4929-b407-b5b1e072fa60/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"block_preserve_scale": true
			},
			"parent_id": "853bd534-6c65-4c3b-809b-fd098de87bea",
			"parent_table": "block",
			"file_ids": [
				"b291bdb0-3790-4929-b407-b5b1e072fa60"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/df48344a-82f9-4507-8ea1-b0f945de4a3b.png"
		},
		{
			"id": "66810c39-00de-4856-8e70-2fbc4fceba15",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нельзя:\n• искажать размеры логотипа,\n• нарушать границы охранного поля,\n• добавлять дескриптор,\n• использовать логотип на неконтрастных фонах,\n• использовать устаревшую версию логотипа на плашке."
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6dc97590-0a40-431d-a051-a833925ba292",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "853bd534-6c65-4c3b-809b-fd098de87bea",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c405eacf-591a-42e7-95df-200b03ff9777",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "649e903b-0d5f-4c21-a15b-bfabf215a5db",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "853bd534-6c65-4c3b-809b-fd098de87bea",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Фирменные цвета",
			"id": "6399d5ab-cd1a-4e6d-a196-624372dcdf26"
		},
		{
			"title": "Логотип",
			"id": "71181440-3a6d-411a-b155-9df72340128d"
		},
		{
			"title": "Маскот продуктов Mail",
			"id": "ba5ea0e3-6688-438c-8ab9-fcf10e60dc92"
		}
	]
}} />
);

export default NotionBranding;
